import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class AvatarCollectionService {

    getAllAvatars(): Array<{ id: number, icon: string }> {
        let avatarImageCollection: { id: number, icon: string }[] = [{ 'id': 1, 'icon': 'assets/common/images/photos/Group113995.svg' },
        { 'id': 2, 'icon': 'assets/common/images/photos/Group113996.svg' },
        { 'id': 3, 'icon': 'assets/common/images/photos/Group113998.svg' },
        { 'id': 4, 'icon': 'assets/common/images/photos/Group142242.svg' },
        { 'id': 6, 'icon': 'assets/common/images/photos/Group142244.svg' },
        { 'id': 7, 'icon': 'assets/common/images/photos/Group142245.svg' },
        { 'id': 8, 'icon': 'assets/common/images/photos/Group142246.svg' },
        { 'id': 9, 'icon': 'assets/common/images/photos/Group142247.svg' },
        { 'id': 10, 'icon': 'assets/common/images/photos/Group142248.svg' },
        { 'id': 11, 'icon': 'assets/common/images/photos/Group142249.svg' },
        { 'id': 12, 'icon': 'assets/common/images/photos/Group142250.svg' },
        { 'id': 13, 'icon': 'assets/common/images/photos/Group142251.svg' },
        { 'id': 14, 'icon': 'assets/common/images/photos/Group142252.svg' },
        { 'id': 15, 'icon': 'assets/common/images/photos/Group142253.svg' },
        { 'id': 16, 'icon': 'assets/common/images/photos/Group142254.svg' },
        { 'id': 17, 'icon': 'assets/common/images/photos/Group142255.svg' },
        { 'id': 18, 'icon': 'assets/common/images/photos/Group142256.svg' },
        { 'id': 19, 'icon': 'assets/common/images/photos/Group142257.svg' },
        { 'id': 20, 'icon': 'assets/common/images/photos/Group142258.svg' }];
        return avatarImageCollection;
    }
}
